import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import { visibilitySettings } from '../../../utils';
import BackstageRowGrid from '../../BackstageRowGrid';

import ArtistSimilarArtistRowItem from './ArtistSimilarArtistRowItem';

const integrationData = {
  contentSection: BackstageConstants.BackstageSections.SIMILAR_ARTISTS,
};
const SimilarArtistsWithLogger = D.withVisibilityLogger(
  { contentSection: BackstageConstants.BackstageSections.SIMILAR_ARTISTS },
  visibilitySettings({ isRowComponent: true, useMemo: true }),
)(BackstageRowGrid);

const ArtistSimilarArtists = props => {
  const { similarArtists } = props;
  if (!similarArtists || similarArtists.length <= 0) return null;

  return (
    <D.ContentSection
      isSimilarArtists={true}
      title={<FormattedMessage {...BackstageConstants.messages.fansAlsoLike} />}
    >
      <D.AppContextIntegrationData data={integrationData}>
        <SimilarArtistsWithLogger>
          {similarArtists.map(similarArtist => {
            const pandoraId = get(similarArtist, 'id', '');
            return (
              <ArtistSimilarArtistRowItem
                key={pandoraId}
                pandoraId={pandoraId}
                imgUrl={get(similarArtist, 'art.artUrl', '')}
                name={get(similarArtist, 'name', '')}
                urlPath={get(similarArtist, 'urlPath', '')}
              />
            );
          })}
        </SimilarArtistsWithLogger>
      </D.AppContextIntegrationData>
    </D.ContentSection>
  );
};

ArtistSimilarArtists.propTypes = {
  similarArtists: PropTypes.array,
};

export default ArtistSimilarArtists;
